import {createImageObject} from '../utils';
import {merge, flatten, cloneDeep, uniqBy} from 'lodash';
import {getImageSize} from '@/lib/helper';
import {
    placeHolder,
    suggestImg,
    MIN_IMAGE_INPUT_SIZE,
    MIN_IMAGE_RATIO,
    MAX_IMAGE_RATIO,
    MAX_IMAGE_INPUT_SIZE,
    VERTICAL,
    HORIZONTAL,
    AUTOSIZE,
    FIXEDRATIO,
    SMARTCROPTYPE,
    AVERAGECROPTYPE
} from '@/views/V2/image/crop/utils/constants.js';

function checkSmartFrom(form) {
    const {sizeType} = form;
    const formData = form[sizeType];
    const {ratio, size, width, height} = formData;
    if (sizeType === FIXEDRATIO) {
        if (!ratio || !size) {
            return false;
        }
        const submitSize = size.split('*').map(item => Number(item));
        return {
            ratio,
            width: submitSize[0],
            height: submitSize[1]
        };
    }
    if (sizeType === AUTOSIZE) {
        if (formData.customTips) {
            return false;
        }
        return {
            width: Number(width),
            height: Number(height)
        };
    }
    return false;
}
function checkAverageForm(form) {
    const {sliderValue} = form;
    let verticalNumber = sliderValue[VERTICAL] || 1;
    let horizontalNumber = sliderValue[HORIZONTAL] || 1;
    if (verticalNumber > 1 || horizontalNumber > 1) {
        return {
            verticalNumber,
            horizontalNumber
        };
    }
    return false;
}
async function formatAverageParams({verticalNumber, horizontalNumber}, imageList) {
    if (!verticalNumber || !horizontalNumber || !imageList || !imageList.length) {
        return [];
    }
    let correctSizeList = imageList;
    const promises = imageList.map(item => {
        return getImageSize(item.url)
        .then(({width, height}) => {
            if (width > 0 && height > 0) {
                return {...item, width, height};
            }
            return item;
        });
    });
    await Promise.all(promises)
    .then(newList => {
        correctSizeList = newList;
    })
    .catch(err => {
        correctSizeList = imageList;
    });
    return flatten(correctSizeList.map(item => getCropParams(verticalNumber, horizontalNumber, item)));
}
function formatSmartParams({width, height}, imageList) {
    if (!width || !height || !imageList || !imageList.length) {
        return [];
    }
    const submitImageList = imageList.map(item => {
        return {
            url: item.url,
            width: item.width,
            height: item.height
        };
    });
    return {
        imageList: submitImageList,
        width,
        height,
        retMode: 'url'
    };
}
function getCropParams(verticalNumber, horizontalNumber, {url: imageUrl, width: imageWidth, height: imageHeight}) {
    let offsetWidth = parseInt(imageWidth / verticalNumber, 10);
    let offsetHeight = parseInt(imageHeight / horizontalNumber, 10);
    const verticalList = Array(verticalNumber).fill(1).map((_, index) => index);
    const horizontalList = Array(horizontalNumber).fill(1).map((_, index) => index);
    let offsetY = 0;
    let targetSizes = horizontalList.map(y => {
        offsetY = offsetHeight * y;
        return verticalList.map(x => {
            return {
                offsetX: offsetWidth * x,
                offsetY,
                offsetWidth,
                offsetHeight,
                width: offsetWidth,
                height: offsetHeight
            };
        });
    });
    targetSizes = flatten(targetSizes);
    const defaultParams = {
        productLine: 'CHUANGYIGUAN',
        needMola: false,
        addCropImage: false,
        imageUrl,
        imageWidth,
        imageHeight,
        cropStrategy: 'CROP_CUSTOM'
    };
    let submitParamList = [{
        ...defaultParams,
        targetSizes: targetSizes
    }];
    const len = targetSizes.length;
    if (len > 5) {
        let newList = [];
        let sliceNumbers = Array(Math.ceil(targetSizes.length / 5)).fill(1).map((_, index) => index);
        sliceNumbers.forEach(i => {
            newList.push({
                ...defaultParams,
                targetSizes: targetSizes.slice(i * 5, Math.min((i + 1) * 5), len)
            });
        });
        submitParamList = newList;
    }
    return submitParamList;
}

function updateRecordEditParams(displayImg = [], extraParams) {
    let recordList = [];
    displayImg.forEach((group, groupIndex) => {
        const {verticalNumber, horizontalNumber, imageList} = group;
        imageList.forEach((item, itemIndex) => {
            const editorParams = {
                ...extraParams,
                verticalNumber: verticalNumber,
                horizontalNumber: horizontalNumber,
                groupIndex,
                itemIndex
            };
            recordList.push({
                recordId: item.recordId,
                editorParam: JSON.stringify(editorParams)
            });
        });
    });
    return recordList;
}

const defaultState = {
    title: '批量裁剪',
    VERTICAL,
    HORIZONTAL,
    AUTOSIZE,
    FIXEDRATIO,
    SMARTCROPTYPE,
    AVERAGECROPTYPE,
    uploadImg: [],
    displayImg: [],
    recordImg: [],
    editLoading: false,
    toolBarLoading: false,
    placeHolder,
    suggestImg,
    maxImgNum: 30,
    historyParams: {
        pageNo: 1,
        pageSize: 10,
        taskType: [11]
    },
    pageLoadingStatus: {
        show: false,
        title: ''
    },
    cropFormData: {
        cropType: SMARTCROPTYPE, // smart, average
        [SMARTCROPTYPE]: {
            sizeType: FIXEDRATIO, // autoSize, fixedRatio
            [FIXEDRATIO]: {
                ratio: '1:1',
                size: '600*600',
                customTips: '' // 校验报错提示
            },
            [AUTOSIZE]: {
                width: 600,
                height: 600,
                customTips: '' // 校验报错提示
            }
        },
        [AVERAGECROPTYPE]: {
            sliderValue: {
                [VERTICAL]: 0, // 等分裁切份数 2-5
                [HORIZONTAL]: 0
            }
        }
    },
    canSubmit: false,
    submitForm: {}
};
export default {
    namespaced: true,
    state: cloneDeep(defaultState),
    mutations: {
        CHANGE_UPLOAD_IMG(state, data) {
            // 必须得去重，后面会根据url再组合结果，如果不去重，组合出来会有问题
            state.uploadImg = uniqBy(data, item => item.url);
        },
        CHANGE_RECORD_IMG(state, data) {
            state.recordImg = data;
        },
        CHANGE_DISPLAY_IMG(state, data) {
            state.displayImg = data;
        },
        CHANGE_EDIT_LOADING(state, data) {
            state.editLoading = data;
        },
        CHANGE_TOOLBAR_LOADING(state, data) {
            state.toolBarLoading = data;
        },
        CHANGE_PAGE_STATUS(state, data) {
            state.pageLoadingStatus = data;
        },
        CHANGE_CROP_FORM_DATA(state, data) {
            state.cropFormData = merge(state.cropFormData, data);
        },
        CHANGE_VALID_STATUS(state, val) {
            state.canSubmit = val;
        },
        CHANGE_SUBMIT_FORM(state, data) {
            state.submitForm = data;
        },
        RESET_STATE(state) {
            Object.entries(cloneDeep(defaultState)).forEach(([key, val]) => {
                state[key] = val;
            });
        },
        RESET_FORM(state) {
            Object.entries(cloneDeep(defaultState)).forEach(([key, val]) => {
                if (key !== 'displayImg') {
                    state[key] = val;
                }
            });
        }
    },
    actions: {
        changeUploadImg({dispatch, commit}, data) {
            commit('CHANGE_UPLOAD_IMG', data);
            dispatch('changeValidStatus');
        },
        changeDisplayImg({commit}, data) {
            commit('CHANGE_DISPLAY_IMG', data);
        },
        changePageStatus({commit}, data) {
            commit('CHANGE_PAGE_STATUS', data);
        },
        // 更改cropForm数据
        changeFormData({dispatch, commit}, data) {
            commit('CHANGE_CROP_FORM_DATA', data);
            dispatch('changeValidStatus');
        },
        resetState({commit}) {
            commit('RESET_STATE');
        },
        resetForm({commit}) {
            commit('RESET_FORM');
        },
        changeValidStatus({commit, state}) {
            const {cropFormData, uploadImg} = state;
            if (uploadImg.length < 1) {
                commit('CHANGE_VALID_STATUS', false);
                return;
            }
            const cropType = cropFormData.cropType;
            const cropForm = cropFormData[cropType];
            let checkRes = false;
            if (cropType === SMARTCROPTYPE) {
                checkRes = checkSmartFrom(cropForm);
            }
            else if (cropType === AVERAGECROPTYPE) {
                checkRes = checkAverageForm(cropForm);
            }
            commit('CHANGE_VALID_STATUS', !!checkRes);
            checkRes && commit('CHANGE_SUBMIT_FORM', {
                cropType,
                ...checkRes
            });
        },
        // 获取创作纪录
        async getHistory({commit, state}, model) {
            try {
                const res = await model.imageCreate.getHistory(state.historyParams);
                const recordImgList = res.listData.map(i => {
                    let recordList = i.records;
                    try {
                        const record = recordList[0];
                        const {cropType} = JSON.parse(record.ext);
                        // 精简裁图无需展示手动裁图功能
                        if (cropType === 'simplyCropImage') {
                            recordList = recordList.map(item => {
                                item.noCropOut = true;
                                return item;
                            });
                        }
                    }
                    catch (err) {
                        console.log(err);
                    }
                    return recordList;
                }).filter(item => item !== undefined);

                commit('CHANGE_RECORD_IMG', recordImgList);
            }
            catch (err) {
                throw err;
            }
        },
        // 图片上传 获取主体
        async handleImagePickerConfirm({dispatch, commit, state}, info) {
            const {imageList, change = false} = info;
            const uploadImg = imageList.map(item => ({
                url: item.url,
                width: item.width,
                height: item.height
            }));
            let allUploadImg = [];
            if (change) {
                // 整个更换上传图片列表
                allUploadImg = uploadImg;
            }
            else {
                // 增加图片
                allUploadImg = state.uploadImg.concat(uploadImg);
            }
            dispatch('changeUploadImg', allUploadImg);
        },
        // 裁图按钮提交
        async handleCropSubmit({commit, state}, model) {
            commit('CHANGE_TOOLBAR_LOADING', true);
            try {
                const {uploadImg, submitForm, cropFormData} = state;

                let params = {};
                let displayImg = [];
                if (submitForm.cropType === SMARTCROPTYPE) {
                    params = {
                        ...formatSmartParams(submitForm, uploadImg),
                        imageGenerateType: 'NEW_SIMPLE_AUTO_CROP_MODEL'
                    };
                    const baseDisplayImg = params.imageList.map((_, index) => {
                        return {
                            imageList: [{...createImageObject({recordId: index}), taskId: -1}]
                        };
                    });
                    commit('CHANGE_DISPLAY_IMG', baseDisplayImg);
                    const data = await model.imageCreate.cropImageSmart(params);
                    displayImg = data.map(img => {
                        return {
                            verticalNumber: 1,
                            horizontalNumber: 1,
                            imageList: [{
                                ...img,
                                ...createImageObject({
                                    url: img.url,
                                    recordId: img.recordId,
                                    width: img.width,
                                    height: img.height
                                }),
                                ratio: submitForm.ratio
                            }]
                        };
                    });
                }
                else if (submitForm.cropType === AVERAGECROPTYPE) {
                    const cropImageList = await formatAverageParams(submitForm, uploadImg);
                    params = {
                        cropImageList,
                        imageGenerateType: 'NEW_SIMPLE_AUTO_CROP_MODEL'
                    };
                    const baseDisplayImg = uploadImg.map((item, index) => {
                        return {
                            imageList: [{...createImageObject({recordId: index}), taskId: -1}]
                        };
                    });
                    const verticalNumber = submitForm.verticalNumber;
                    const horizontalNumber = submitForm.horizontalNumber;
                    commit('CHANGE_DISPLAY_IMG', baseDisplayImg);
                    const data = await model.imageCreate.cropImageAverage(params);
                    let resultList = [];
                    data.forEach(item => {
                        let newList = item.cropImageList.map(img => {
                            img.orgUrl = item.orgUrl;
                            img.orgWidth = item.width;
                            img.orgHeight = item.height;
                            return img;
                        });
                        newList = newList.map(img => {
                            return {
                                ...img,
                                ...createImageObject({
                                    url: img.url,
                                    recordId: img.recordId,
                                    width: img.width,
                                    height: img.height
                                }),
                                noCropOut: true
                            };
                        });
                        // 由于底层的精简裁图接口，对一张图最多裁成5份，所以传参的时候进行了拆分
                        // 现在拿到结果后还要拼起来
                        const aimOrgUrl = newList[0]?.orgUrl || '';
                        const aimIndex = resultList.findIndex(item => item[0] && (item[0].orgUrl === aimOrgUrl));
                        if (aimIndex > -1) {
                            resultList[aimIndex] = resultList[aimIndex].concat(newList);
                        }
                        else {
                            resultList.push(newList);
                        }
                    });
                    displayImg = resultList.map(item => {
                        return {
                            verticalNumber,
                            horizontalNumber,
                            imageList: item
                        };
                    });
                }
                commit('CHANGE_DISPLAY_IMG', displayImg);
                const newRecordsList = updateRecordEditParams(displayImg, {uploadImg, submitForm, cropFormData});
                await model.imageCreate.updateCutoutRecord({
                    recordList: newRecordsList
                });
            }
            catch (err) {
                console.error(err.message);
                throw err;
            }
            finally {
                commit('CHANGE_TOOLBAR_LOADING', false);
            }
        }
    }
};